<template lang="pug">
  e-modal(
  @confirm="runOperation()"
  @close="$emit('close')"
  title="Сформировать начисление"
  saveBtnLabel="Сформировать"
  ref="modal"
  :autoHeight="true"
  )
    slot
      e-form(
      :formValidator="formValidator"
      form-class="fix-elements-overflow-problem"
      :enable-perfect-scrollbar="false"
      )
        div.body
          div.col
            e-form-group(
            label="Период"
            inputType="calendar"
            name="date"
            :model="fields"
            :tabView="tabView"
            :required="true"
            type="month"
            format="MM/yyyy"
            )
</template>

<script>
import { wasteGenerators } from '@/api/api-endpoints'
import FormValidator from '@/components/form/form-validator'

export default {
  name: 'operation-create',
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tabView: '',
      fields: {
        date: '',
      },
    }
  },
  methods: {
    runOperation: async function () {
      if (!this.model.id) {
        this.$e.warningBox('Действие станет доступно после сохранеия')
        return
      }

      const { hasError } = this.formValidator.validate()
      if (hasError === true) {
        return
      }

      try {
        this.$bar.start()
        this.$refs.modal.freezeAll()
        await this.$store.dispatch('createModel', {
          url: wasteGenerators.bankBookOperationCreate(this.model.id),
          data: this.fields,
        })
        this.$e.successBox()
        this.$emit('updated')
        this.$emit('close')
      } catch (e) {
        if (e && +e.status === 422) {
          let { notFoundedErrorFieldsText } =
            this.formValidator.handleServerErrors(e, this)
          if (notFoundedErrorFieldsText) {
            this.$e.errorBox('Некорректно заполнены поля', {
              text: notFoundedErrorFieldsText,
            })
          }
        } else {
          this.$e.errorBox(e)
        }
      } finally {
        this.$refs.modal.unFreezeAll()
        this.$bar.finish()
      }
    },
  },
  created() {
    this.formValidator = new FormValidator(this)
  },
}
</script>
